module.exports = __webpack_public_path__ + "static/media/user_name.b7596000.svg";